<template>
  <!-- A aba "Posicoes" e a mesma rota nos dois produtos; o que muda e a tela.
       ETF e NDF nao compartilham coluna nenhuma (o NDF nao tem custo medio nem
       ultimo preco), entao sao componentes irmaos e nao v-ifs internos. -->
  <ndf-positions v-if="portfolioStore.isNdf" :mocked-enabled="mockedEnabled" />
  <portfolio-positions v-else :mocked-enabled="mockedEnabled" />
</template>

<script>
import { mapStores } from 'pinia'
import { usePortfolioStore } from '@/store/portfolioStore.js'
import PortfolioPositions from './PortfolioPositions.vue'
import NdfPositions from './NdfPositions.vue'

export default {
  name: 'PositionsTab',
  components: { PortfolioPositions, NdfPositions },
  props: { mockedEnabled: { type: Boolean } },
  computed: {
    ...mapStores(usePortfolioStore),
  },
}
</script>
